export enum SideNavPosition {
  start,
  end
}
